
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.1875 0H2.8125C1.25907 0 0 1.25907 0 2.8125V19.6875C0 21.2409 1.25907 22.5 2.8125 22.5H6.5625V30L18.75 22.5H27.1875C28.7409 22.5 30 21.2409 30 19.6875V2.8125C30 1.25907 28.7409 0 27.1875 0ZM26.25 18.75H17.8125L10.3125 23.4375L9.375 18.75H3.75V3.75H26.25V18.75Z","fill":"#fff"}})])
      }
    
      }
    